import classNames from '@jd/jmtd-tools/es/classnames';
import Highlight from '@jd/jmtd/es/HighLight';
import Label from '@jd/jmtd/es/Label';
import Text from '@jd/jmtd/es/Text';
import PropTypes from 'prop-types';
import React from 'react';
export default function EntityDropdownOption(_ref) {
  var className = _ref.className,
      children = _ref.children,
      value = _ref.value,
      valueLabel = _ref.valueLabel,
      keyword = _ref.keyword,
      img = _ref.img;
  var main = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "jmtp-entity-dropdown-option-label"
  }, /*#__PURE__*/React.createElement(Label, {
    theme: "light"
  }, /*#__PURE__*/React.createElement(Highlight, {
    keyword: keyword
  }, children || '未知'))), /*#__PURE__*/React.createElement(Text, {
    className: "jmtp-entity-dropdown-option-value",
    size: "regular",
    semantic: "regular"
  }, valueLabel && /*#__PURE__*/React.createElement("div", {
    className: "jmtp-entity-dropdown-option-value-label"
  }, valueLabel, "\uFF1A"), /*#__PURE__*/React.createElement(Label, {
    className: "jmtp-entity-dropdown-option-value-value",
    theme: "light"
  }, /*#__PURE__*/React.createElement(Highlight, {
    keyword: keyword
  }, value))));
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, 'jmtp-entity-dropdown-option', {
      'jmtp-entity-dropdown-option-with-img': !!img
    })
  }, img ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    className: "jmtp-entity-dropdown-option-img",
    src: img,
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "jmtp-entity-dropdown-option-main"
  }, main)) : main);
}
EntityDropdownOption.propTypes = {
  children: PropTypes.node,
  value: PropTypes.node,
  className: PropTypes.string,
  valueLabel: PropTypes.node,
  keyword: PropTypes.string,
  img: PropTypes.string
};
EntityDropdownOption.defaultProps = {
  children: null,
  value: null,
  className: '',
  valueLabel: null,
  keyword: '',
  img: null
};